import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://pmaster.uz';

// Organization schema
const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'PMaster',
  url: BASE_URL,
  logo: `${BASE_URL}/logo.png`,
  description: "Kompyuter, Printer, Telefon, Muzlatgich, Konditsioner va turli maishiy texnika sozlash ustaxonalari uchun boshqarish tizimi",
  foundingDate: '2024',
  areaServed: {
    '@type': 'Country',
    name: 'Uzbekistan',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    availableLanguage: ['Uzbek', 'Russian', 'English'],
  },
  sameAs: [],
};

// SoftwareApplication schema
const softwareSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'PMaster',
  applicationCategory: 'BusinessApplication',
  applicationSubCategory: 'CRM',
  operatingSystem: 'Web',
  offers: [
    {
      '@type': 'Offer',
      name: 'Free',
      price: '0',
      priceCurrency: 'UZS',
      description: "Bepul tarif - 10 ta ta'mirlash",
    },
    {
      '@type': 'Offer',
      name: 'Premium',
      price: '129000',
      priceCurrency: 'UZS',
      description: "Premium tarif - cheksiz ta'mirlash, Excel hisobotlar",
    },
  ],
  featureList: [
    "Ta'mirlash buyurtmalarini boshqarish",
    'Mijozlar bazasi',
    'Shtrix-kod va QR-kod',
    'SMS xabarnomalar',
    'Moliyaviy hisobotlar',
    'PWA mobil ilova',
  ],
  screenshot: `${BASE_URL}/og-image.png`,
  url: BASE_URL,
  author: organizationSchema,
  availableLanguage: ['uz', 'ru', 'en'],
  countriesSupported: 'UZ',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    bestRating: '5',
    worstRating: '1',
    ratingCount: '5',
    reviewCount: '5',
  },
  review: [
    {
      '@type': 'Review',
      author: { '@type': 'Person', name: 'Aziz K.' },
      datePublished: '2026-03-15',
      reviewBody: 'pMaster orqali mijozlarimni kuzatish juda osonlashdi. Oldin daftarda yozardim, endi hammasi telefonimda.',
      reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
    },
    {
      '@type': 'Review',
      author: { '@type': 'Person', name: 'Dilshod R.' },
      datePublished: '2026-03-20',
      reviewBody: "QR kod yorliqlari eng zo'r funksiya. Mijoz kelganda qurilmasini tezda topaman.",
      reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
    },
    {
      '@type': 'Review',
      author: { '@type': 'Person', name: 'Nodira A.' },
      datePublished: '2026-03-25',
      reviewBody: "Kunlik kassa hisoboti menga har kuni qancha pul ishlaganimni ko'rsatadi. Juda foydali!",
      reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
    },
    {
      '@type': 'Review',
      author: { '@type': 'Person', name: 'Sardor M.' },
      datePublished: '2026-04-01',
      reviewBody: "SMS xabarnomalar tufayli mijozlarim qurilmasi tayyor bo'lganda biladi. Professional ko'rinadi.",
      reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
    },
    {
      '@type': 'Review',
      author: { '@type': 'Person', name: 'Jasur T.' },
      datePublished: '2026-04-05',
      reviewBody: 'Bepul rejada boshladim, hozir Premium ishlataman. Har bir tiyin arziydi.',
      reviewRating: { '@type': 'Rating', ratingValue: '4', bestRating: '5' },
    },
  ],
};

// LocalBusiness schema for repair shops using PMaster
const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${BASE_URL}/#business`,
  name: 'PMaster - Repair Shop Management',
  url: BASE_URL,
  description:
    "O'zbekistondagi kompyuter, printer, telefon, muzlatgich, konditsioner va turli maishiy texnika sozlash ustaxonalari uchun boshqarish tizimi",
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'UZ',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 41.2995,
    longitude: 69.2401,
  },
  priceRange: "Bepul - 129,000 so'm/oy",
  openingHours: 'Mo-Sa 09:00-18:00',
};

// FAQ schema for landing page
const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: "PMaster nima?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "PMaster - bu O'zbekistondagi kompyuter, printer, telefon, muzlatgich, konditsioner va turli maishiy texnika sozlash ustaxonalari uchun boshqarish tizimi. Buyurtmalarni qabul qilish, mijozlar bazasini yuritish, shtrix-kod va QR-kodlar yaratish, SMS xabarnomalar yuborish va moliyaviy hisobotlar olish imkonini beradi.",
      },
    },
    {
      '@type': 'Question',
      name: "PMaster bepulmi?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Ha, PMaster bepul tarifga ega bo'lib, 10 tagacha ta'mirlash buyurtmasini boshqarish imkonini beradi. Ko'proq imkoniyatlar uchun Premium tarif mavjud.",
      },
    },
    {
      '@type': 'Question',
      name: "PMaster qaysi tillarda ishlaydi?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "PMaster o'zbek, rus va ingliz tillarida ishlaydi. Foydalanuvchi istalgan vaqtda tilni o'zgartirishi mumkin.",
      },
    },
  ],
};

interface JsonLdProps {
  type?: 'landing' | 'app' | 'status';
}

export default function JsonLd({ type = 'landing' }: JsonLdProps) {
  const schemas = [organizationSchema, softwareSchema];

  if (type === 'landing') {
    schemas.push(localBusinessSchema, faqSchema);
  }

  return (
    <Helmet>
      {schemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
